import { Component, OnInit } from '@angular/core';
import {MatDialogRef} from '@angular/material/dialog';
import {BaseUser} from '../../../core/models/base-user.model';
import {DeactivateTotpResponse} from '../../../core/models/allauth.model';

@Component({
  selector: 'cm-logout-confirm-dialog',
  templateUrl: './logout-confirm-dialog.component.html',
  styleUrls: ['./logout-confirm-dialog.component.scss']
})
export class LogoutConfirmDialogComponent implements OnInit {
  dialogRef: MatDialogRef<LogoutConfirmDialogComponent>;
  currentUser: BaseUser;

  constructor() { }

  ngOnInit(): void {
  }

  logout($event): void {
    this.dialogRef.close({ success: true, currentUser: this.currentUser });
  }

  cancel($event): void {
    this.dialogRef.close({ success: false, currentUser: this.currentUser });
  }
}
